import React from 'react';
import { hex2rgba } from "../resources/utils";

import styles from './TierCard.module.scss';

import Media from "./Media";

const TierCard = ({ image, title, id, perks, accent }) => {
  return (
    <div key={id} className={styles.tierCard}>
      <Media image={image}/>
      <div className={styles.content}>
        { title && <h3>{ title }</h3>}
        {
          perks.map((x, i) => {
            return (
              <div key={i}>
                <div style={{ background: accent ? hex2rgba(accent, 0.15) : undefined }}>
                  <svg style={{ color: accent ? `#${accent}` : undefined }} aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                </div>
                <span>{x}</span>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default TierCard;
